import { useState } from 'react';
import { isValidPhoneNumber } from 'react-phone-number-input';

import { Modal } from '@/components';
import { ButtonOutlinedSmall, ButtonSmall } from '@/components/Button';
import { PhoneInput } from '@/components/Inputs';
import {
  useCreateNotificationMethodMutation,
  useUpdateNotificationMethodMutation,
} from '@/store/notification-settings/notification-settings.store';
import {
  type NotificationMethod,
  NotificationMethodType,
} from '@/store/notification-settings/notification-settings.types';

import s from '../NotificationsSettingsPage.module.scss';

type Props = {
  onClose: () => void;
  method?: NotificationMethod;
};

export const EditPhoneModal = ({ onClose, method }: Props) => {
  const { mutate: createMethod } = useCreateNotificationMethodMutation();
  const { mutate: updateMethod } = useUpdateNotificationMethodMutation();
  const [draft, setDraft] = useState(method?.data ?? '+1');
  const [touched, setTouched] = useState(false);

  const trimmed = draft.trim();
  const error =
    trimmed && !isValidPhoneNumber(trimmed) ? 'Please enter a valid mobile number.' : undefined;

  const save = () => {
    if (!trimmed || error) return;
    if (method) {
      updateMethod({ id: method.id, type: method.type, data: trimmed, active: method.active });
    } else {
      createMethod({ type: NotificationMethodType.PHONE, data: trimmed });
    }
    onClose();
  };

  return (
    <Modal open onClose={onClose} title="Edit Mobile Number">
      <div className={s.modalBody}>
        <PhoneInput
          label="Mobile Number"
          value={draft}
          onChange={(value) => {
            setDraft(value ?? '');
            setTouched(true);
          }}
          error={touched ? error : undefined}
        />
        <div className={s.modalActions}>
          <ButtonOutlinedSmall onClick={onClose}>Cancel</ButtonOutlinedSmall>
          <ButtonSmall onClick={save} disabled={!trimmed || !!error}>
            Save
          </ButtonSmall>
        </div>
      </div>
    </Modal>
  );
};
